module.exports = __webpack_public_path__ + "static/media/1.33feaaf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9018/1.jpg
// module id = 866
// module chunks = 0